import { createContext, useContext } from 'react';

/** Idle-warning state + handlers: provided by AuthProvider, consumed by SessionTimeoutWarningHost (inside LocaleProvider). */
export const SessionWarningContext = createContext(null);
export function useSessionWarning() {
  return useContext(SessionWarningContext);
}
